import { css } from '@emotion/core'
import { NoticeLoading } from '@fs/zion-icon'
import { Row, Separator } from '@fs/zion-ui'
import React, { useMemo } from 'react'

// The spinner animation is 1s linear infinite on the svg element. By applying a negative
// animation-delay equal to how far we are through the current second, each new spinner
// instance appears to continue mid-cycle rather than restarting at 0°.
const getAnimationDelayCss = (delay) => css`
  svg {
    /* !important needed to override the library class at equal specificity */
    animation-delay: ${delay}s !important;
  }
`

export default function CenteredLoadingSpinner({ size = 'lg', separatorSize = 'xxl' }) {
  // Captured once at mount so re-renders don't shift the animation offset
  const animationDelayCss = useMemo(() => getAnimationDelayCss(-(Date.now() % 1000) / 1000), [])

  return (
    <div data-testid="loading">
      <Separator size={separatorSize} />
      <Row alignX="center">
        <div css={animationDelayCss}>
          <NoticeLoading size={size} />
        </div>
      </Row>
      <Separator size={separatorSize} />
    </div>
  )
}
